exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cls-1 {\r\n        fill: url(#radial-gradient);\n}\n.cls-2 {\r\n        fill: #78be20;\n}\n.cls-3 {\r\n        fill: #3c864d;\r\n        opacity: 0.3;\n}\n.cls-4 {\r\n        fill: #fff;\n}\r\n", ""]);

// exports
